<template>
  <div
    :class="[
      'ui',
      'button',
      icon || value,
    ]"
    :id="icon || value"
    role="button"
    tabindex="0"
    :aria-label="label || icon || value"
  >
    <a
      v-if="icon"
      aria-hidden="true"
    >
      <svg
        v-if="shape"
        preserveAspectRatio="none"
        :viewBox="shape.viewBox"
      >
        <path
          :d="shape.d"
        />
      </svg>
    </a>
    <a
      v-else
      aria-hidden="true"
    >
      {{ value }}
    </a>
  </div>
</template>

<script>
export default {
  name: 'Button',
  props: [
    'value',
    'icon',
    'label'
  ],
  computed: {
    shape() { return this.icon && require(`@/assets/icons/${this.icon}.js`).default },
  },
}
</script>

<style scoped>

.button a {
  display: flex;
  justify-content: center;
  align-items: center;
}
.button a svg,
.button a img {
  padding: 0.2em;
  width: 1.5em;
  height: 100%;
}
.button a svg path {
  fill: var(--dark2)
}
.button a:hover svg path {
  fill: var(--light2);
}
.button a:hover {
  background: var(--back);
  color: var(--light2);
}
.button.play,
.button.pause,
.button.loading {
  z-index: 1;
}

.button.loading svg {
  animation: pulse var(--slow) ease alternate-reverse infinite;
}

@keyframes pulse {
  0% { transform: scale(1.2); }
  100% { transform: scale(1); }
}

.isMobile .button {
  padding: 0.5em;
}
.isMobile .button a svg {
  padding: 0em;
  width: 1em;
  height: 1em;
}

</style>
